export const TIPO_ACCESORIO_CAUSIDICO_CAMPO = {
    51: 'importeMayorC1',
    52: 'importeMayorC2',
    53: 'importeMayorC3',
    54: 'importeMayorC4',
    55: 'importeMayorC5',
    56: 'importeMayorC6'
}
